import { Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';

import { UserService } from '../../../user.service';

@Component({
  selector: 'app-user-debug-info',
  templateUrl: './user-debug-info.component.html',
  styleUrls: ['./user-debug-info.component.scss'],
})
export class UserDebugInfoComponent implements OnInit {
  public currentUserEmail: string;
  // test
  public readonly users = [
    {
      name: '관리자',
      email: 'channel-test+owner@buk.io',
    },
    {
      name: '총괄 편집자',
      email: 'channel-test+admin@buk.io',
    },
    {
      name: '편집자',
      email: 'channel-test+editor@buk.io',
    },
    {
      name: '작가',
      email: 'channel-test+writer@buk.io',
    },
  ];

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.user$
      .pipe(filter((user) => !!user))
      .subscribe((user) => (this.currentUserEmail = user.email));
  }
}
